<script lang="ts">
  import { AlertTriangle } from "lucide-svelte";
  import { createEventDispatcher } from "svelte";

  import Popup from "./Popup.svelte";
  import PopupActions from "./PopupActions.svelte";

  const dispatch = createEventDispatcher<{ confirm: void; cancel: void }>();

  export let open: boolean;
  export let title: string;
  export let disabled: boolean = false;

  let cancelButton: HTMLButtonElement;

  function close() {
    open = false;
  }

  function confirm() {
    dispatch("confirm");
    close();
  }
</script>

<Popup
  {open}
  on:close={close}
  {title}
  icon={AlertTriangle}
  initialFocus={cancelButton}
>
  <slot />

  <PopupActions>
    <button bind:this={cancelButton} class="btn btn-outlined" on:click={close}>
      Cancel
    </button>
    <button class="btn btn-outlined btn-red" {disabled} on:click={confirm}>
      Confirm
    </button>
  </PopupActions>
</Popup>
